export enum FrequencyRange {
  subBass = "sub-bass",
  bass = "bass",
  lowMids = "low-mids",
  mids = "mids",
  hiMids = "hi-mids",
  presence = "presence",
  brilliance = "brilliance",
}
